/* eslint-disable react/no-unescaped-entities */
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const Contact = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'relative',
        '&::after': {
          position: 'absolute',
          content: '""',
          width: '40%',
          height: '100%',
          zIndex: 1,
          top: 0,
          right: 0,
          backgroundSize: '18px 18px',
          backgroundImage: `radial-gradient(${alpha(
            theme.palette.primary.dark,
            0.4,
          )} 20%, transparent 20%)`,
          opacity: 0.2,
        },
      }}
    >
      <Box position={'relative'} zIndex={2}>
        <Box>
          <Box marginBottom={1}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
              }}
            >
              Get in touch
            </Typography>
          </Box>
          <Box>
            <Typography variant="h6" color={'text.secondary'}>
              We'd love to talk about how we can help you.
            </Typography>
          </Box>
        </Box>
        <Box marginY={3}>
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            title="map"
            marginHeight={0}
            marginWidth={0}
            scrolling="no"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.0352435192153!2d3.2552369147706925!3d6.5172231952858795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8f9275664aa1%3A0xc7e3b525fa32babb!2sTopibro%20Technologies%3A%20Web%20design%20%2FMobile%20App%20Development%20%2F!5e0!3m2!1sen!2sng!4v1648206974762!5m2!1sen!2sng"
            style={{
              minHeight: 300,
              borderRadius: 8,
              filter:
                theme.palette.mode === 'dark'
                  ? 'grayscale(0.5) opacity(0.7)'
                  : 'none',
            }}
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'body1'}
              gutterBottom
              sx={{ fontWeight: 'medium' }}
            >
              Call us:
            </Typography>
            <Typography variant={'subtitle1'}>+234 913 407 9164</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'body1'}
              gutterBottom
              sx={{ fontWeight: 'medium' }}
            >
              Email us:
            </Typography>
            <Typography variant={'subtitle1'}>info@topibrotech.com</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant={'body1'}
              gutterBottom
              sx={{ fontWeight: 'medium' }}
            >
              Address:
            </Typography>
            <Typography variant={'subtitle1'}>
              Topibro Technologies Ijegun, Lagos.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Contact;
